<template>
  <div>
    <v-card elevation="0">
      <v-card-title class="first-title" v-if="isShowRequest">Account</v-card-title>
<!--   Request   -->
      <v-card-title class="next-title" v-if="isShowRequest">Request(Information Entered)</v-card-title>
      <v-card-text class="p-l-40" v-if="isShowRequest">
        <v-layout  row wrap style="height: 96px; margin-bottom: 8px;">
          <v-flex lg3>
            <label class="field-name">Institution Name</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-value">{{ requestData.bankName || 'N/A' }}</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-name">Name</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-value">{{ requestData.name || 'N/A'}} </label>
          </v-flex>
          <v-flex lg3>
            <label class="field-name">Request Code</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-value">{{ requestData.requestCode || 'N/A' }}</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-name">Account Number</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-value">{{ requestData.accountNo || 'N/A' }}</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-name">Email Address</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-value">{{ requestData.email || 'N/A' }}</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-name">Routing Number</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-value">{{ requestData.routingNo || 'N/A' }}</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-name">Phone</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-value">{{ requestData.phone || 'N/A' }}</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-name">Request Status</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-value">{{ assist.tool.getEnumTextByValue(dataType.DecisionLogicRequestCodeStatusEnum, requestData.requestStatus ) || 'Not Started' }}</label>
          </v-flex>
        </v-layout>
      </v-card-text>
<!--   Response   -->
      <v-card-title class="next-title" v-if="isShowResponse">Response(Information Returned)
        <v-btn v-if="loan.loanStatus < dataType.LoanStatus.APPROVED.value" class="m-l-10" small icon color="#5C82E3" @click="getStatus">
          <v-icon>sync</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="p-l-40" v-if="isShowResponse">
        <v-layout row wrap style="height: 90px; margin-bottom: 8px;">
          <v-flex lg3>
            <label class="field-name">Account Name</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-value">{{ responseData.accountName || 'N/A' }}</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-name">Customer Name</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-value">{{ responseData.customerName || 'N/A' }}</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-name">Routing Number</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-value">{{ responseData.routingNumber || 'N/A' }}</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-name">Account Type</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-value">{{ responseData.accountType || 'N/A' }}</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-name">Account Number</label>
          </v-flex>
          <v-flex lg3>
            <label class="field-value" v-if="accountNumberItem.length <= 1">{{ responseData.accountNumber || 'N/A' }}</label>
            <v-select
                v-else
                v-model="accountNumber"
                item-text="value"
                :items="accountNumberItem"
                dense
                hide-details
                height="15"
                class="field-value"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-card-text>
      <!--   summary   -->
      <v-card elevation="0" style="margin-top: 0 !important;" v-if="isShowResponse">
        <v-card-title class="next-title">Summary</v-card-title>
        <v-card-text class="p-l-40">
          <v-layout row wrap style="height: 120px; margin-bottom: 8px;">
            <v-flex lg3>
              <label class="field-name">Available Balance</label>
            </v-flex>
            <v-flex lg3>
              <label class="field-value">{{ assist.tool.formatCurrency(summaryData.availableBalance) || 'N/A'}}</label>
            </v-flex>
            <v-flex lg3>
              <label class="field-name">As of Date</label>
            </v-flex>
            <v-flex lg3>
              <label class="field-value">{{ assist.tool.formatDate(summaryData.asOfDate) || 'N/A' }}</label>
            </v-flex>
            <v-flex lg3>
              <label class="field-name">Current Balance</label>
            </v-flex>
            <v-flex lg3>
              <label class="field-value">{{ assist.tool.formatCurrency(summaryData.currentBalance) || 'N/A' }}</label>
            </v-flex>
            <v-flex lg3>
              <label class="field-name">Average Balance by Month</label>
            </v-flex>
            <v-flex lg3>
              <label class="field-value">{{ assist.tool.formatCurrency(summaryData.avgBalLatestMonth) || 'N/A' }}</label>
            </v-flex>
            <v-flex lg3>
              <label class="field-name">Average Daily Balance</label>
            </v-flex>
            <v-flex lg3>
              <label class="field-value">{{ assist.tool.formatCurrency(summaryData.averageBalance) || 'N/A' }}</label>
            </v-flex>
            <v-flex lg3>
              <label class="field-name">Credit by Month</label>
            </v-flex>
            <v-flex lg3>
              <label class="field-value">{{ assist.tool.formatCurrency(summaryData.creditAmount) || 'N/A' }}</label>
            </v-flex>
            <v-flex lg3>
              <label class="field-name">Debit by Month</label>
            </v-flex>
            <v-flex lg3>
              <label class="field-value">{{ assist.tool.formatCurrency(summaryData.debitAmount) || 'N/A' }}</label>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-card>
<!--  140 Days(798 Transactions)  -->
    <v-card elevation="0" v-if="isShowResponse">
      <v-card-title class="first-title">140 Days({{ transactionsNum }} Transactions)</v-card-title>
      <v-card-text>
        <v-data-table
            class="m-b-30"
            v-model="selected"
            :headers="transactionsHeaders"
            item-key="index"
            :items="transactionData"
            dense
            show-select
            hide-default-footer
            disable-pagination
        >
          <template v-slot:item.transactionDate="{ item }">
            <td style="white-space: nowrap" :class="decideStatus(item)">{{ assist.tool.formatDate(item.transactionDate) }}</td>
          </template>
          <template v-slot:item.status="{ item }">
            <td style="white-space: nowrap" :class="decideStatus(item)">{{ assist.tool.isNotEmpty(item.status) ? item.status.substr(0,1).toUpperCase() + item.status.substr(1) : '' }}</td>
          </template>
          <template v-slot:item.category="{ item }">
            <td :class="decideStatus(item)">{{ item.category }}</td>
          </template>
          <template v-slot:item.typeCodes="{ item }">
            <td style="white-space: nowrap" :class="decideStatus(item)">{{ item.type }}</td>
          </template>
          <template v-slot:item.description="{ item }">
            <td :class="decideStatus(item)">{{ item.description }}</td>
          </template>
          <template v-slot:item.amount="{ item }">
            <td :class="[decideStatus(item), decideAmount(item)]">{{ item.amount >=  0 ? '(+)' + assist.tool.formatCurrency(item.amount) : '(-)' + '$' + Math.abs(item.amount).toFixed(2) }}</td>
          </template>
          <template v-slot:item.balance="{ item }">
            <td :class="decideStatus(item)">{{ item.balance >= 0 ? assist.tool.formatCurrency(item.balance) : '$' + '-' + Math.abs(item.balance).toFixed(2) }}</td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <div v-if="isShowResponse && loanStatusEnum.includes(loan.loanStatus)" class="manual-select-content">
      <v-btn
          dark
          small
          tile
          color="#5C82E3"
          class="btn-action position-abs"
          @click="manualSelectBankRecords">
        Manual Select Bank Records
      </v-btn>
    </div>
  </div>
</template>

<script>
import { DataType, Tool, Popup } from '@/util/index'
import { LIST_TABLE_HEADER } from '@/setting/list-header/list-table-header'
import { OriginationApi, LoanResourceApi } from '@/api/pandaria'
const tool = new Tool()
const popup = new Popup()
export default {
  props: {
    loan: Object,
    loanData: Object,
    dataSource: Object
  },
  data () {
    return {
      item: {},
      assist: {
        tool: tool
      },
      chirpData: {},
      dataType: DataType,
      isShowRequest: false,
      isShowResponse: false,
      summaryHeader: LIST_TABLE_HEADER.SUMMARY_HEADER,
      transactionsHeaders: LIST_TABLE_HEADER.TRANSACTION_HEADER_CHIRP,
      selected: [],
      requestData: {},
      responseData: {},
      summaryData: {},
      transactionData: [],
      accountNumberItem: [],
      accountNumber: '',
      loanStatusEnum: [
        DataType.LoanStatus.AGENT_REVIEW.value,
        DataType.LoanStatus.CORRECTOR_REVIEW.value
      ],
      transactionsNum: ''
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  destroyed () {
    this.$eventBus.$off('setChirpData')
    this.$eventBus.$off('chirpRequestData')
    this.$eventBus.$off('chirpRequestStatus')
  },
  mounted () {
    this.$eventBus.$on('setChirpData', target => {
      this.chirpData = target
      this.initChirpData(target)
    })
    this.$eventBus.$on('chirpRequestData', target => {
      this.isShowRequest = true
      this.isShowResponse = true
      if (tool.isNotEmpty(target)) {
        this.requestData.requestCode = target.requestCode
        this.requestData.requestId = target.requestId
      }
    })
    this.$eventBus.$on('chirpRequestStatus', target => {
      this.requestData.requestStatus = target.requestStatus
    })
  },
  created () {
    this.initRequestData()
  },
  watch: {
    accountNumber (val) {
      this.selected = []
      const filterData = this.chirpData.responseData.filter(item => item.accountNumber === String(val.split('-')[0]))
      this.summaryData = filterData[0].reportData.summary
      this.responseData = filterData[0]
      this.transactionData = filterData[0].reportData.transactions
      if (tool.isNotEmpty(this.transactionData)) {
        for (let i = 0; i < this.transactionData.length; i++) {
          this.transactionData[i].index = i
        }
      }
    },
    chirpData (val) {
      this.initChirpData(val)
    },
    loanData (val) {
      this.initRequestData()
    }
  },
  methods: {
    initRequestData () {
      this.requestData = {}
      if (tool.isNotEmpty(this.loanData)) {
        this.requestData.bankName = this.loanData.bankName
        this.requestData.name = `${tool.isNotEmpty(this.loanData.firstName) ? this.loanData.firstName : ''}
      ${tool.isNotEmpty(this.loanData.middleName) ? this.loanData.middleName : ''}
      ${tool.isNotEmpty(this.loanData.lastName) ? this.loanData.lastName : ''}`
        this.requestData.routingNo = this.loanData.routingNo
        this.requestData.accountNo = this.loanData.accountNo
        this.requestData.email = this.loanData.email
        this.requestData.phone = this.loanData.cellPhone
        if (tool.isNotEmpty(this.loanData.ibvDataList)) {
          this.loanData.ibvDataList.map(item => {
            if (item.provider === DataType.IBVProviderType.CHIRP.value) {
              this.isShowRequest = true
              this.isShowResponse = true
              this.requestData.requestStatus = item.ibvStatus
              this.requestData.requestCode = item.requestCode
              this.requestData.requestId = item.requestId
            }
          })
        } else {
          const requestData = this.store.getters.getChirpRequestData
          const requestStatus = this.store.getters.getChirpRequestStatus
          this.requestData.requestCode = requestData.requestCode
          this.requestData.requestId = requestData.requestId
          this.requestData.requestStatus = requestStatus.requestStatus
        }
      }
    },
    initChirpData (target) {
      if (tool.isNotEmpty(target) && tool.isNotEmpty(target.responseData)) {
        target.responseData.map(item => {
          this.accountNumberItem.push({
            value: `${item.accountNumber}-${item.accountType}`
          })
        })
        this.isShowRequest = true
        this.isShowResponse = true
        this.summaryData = target.responseData[0].reportData.summary
        this.responseData = target.responseData[0]
        this.accountNumber = `${target.responseData[0].accountNumber}-${target.responseData[0].accountType}`
        this.transactionData = target.responseData[0].reportData.transactions
        if (tool.isNotEmpty(this.transactionData)) {
          this.transactionsNum = this.transactionData.length
          for (let i = 0; i < this.transactionData.length; i++) {
            this.transactionData[i].index = i
          }
        }
      }
    },
    getStatus () {
      const $this = this
      const getStatusData = {
        requestId: this.requestData.requestId
      }
      LoanResourceApi.getRequestStatus(getStatusData, function (result) {
        $this.requestData.requestStatus = result.status
        if (result.status === DataType.DecisionLogicRequestCodeStatusEnum.VERIFIED.value) {
          $this.$eventBus.$emit('createIbvStatus', result.status)
        }
        const loanUpdateData = {}
        loanUpdateData.loanId = $this.loan.id
        loanUpdateData.ibvStatus = result.status
        loanUpdateData.provider = DataType.IBVProviderType.CHIRP.value
        loanUpdateData.ibvUpdateType = DataType.IbvUpdateType.GET_REQUEST_STATUS.value
        $this.updateIBVData(loanUpdateData)
        if (result.status === DataType.DecisionLogicRequestCodeStatusEnum.VERIFIED.value) {
          $this.isShowResponse = true
          $this.getReports()
        }
      }, function (result) {
        const message = result?.data?.message || result?.message
        popup.popupForWarning(message)
      })
    },
    getReports () {
      const $this = this
      const getReportsData = {
        requestId: this.requestData.requestId
      }
      LoanResourceApi.getMultipleReportDetails(getReportsData, function (result) {
        const reportData = result
        $this.chirpData = result
        if (tool.isNotEmpty(result) && tool.isNotEmpty(result.risk)) {
          $this.$eventBus.$emit('suspectedRisk', result.risk)
        }
        if (tool.isNotEmpty(reportData)) {
          const reportDetail5 = reportData
          $this.initChirpData(reportDetail5)
          const loanUpdateData = {
            loanId: $this.loanId,
            rawData: JSON.parse(result.rawData),
            ibvData: {
              responseData: result.responseData
            },
            provider: DataType.IBVProviderType.CHIRP.value,
            ibvUpdateType: DataType.IbvUpdateType.GET_MULTIPLE_REPORT.value
          }
          $this.updateIBVData(loanUpdateData)
        }
      }, function (result) {
        const message = result?.data?.message || result?.message
        popup.popupForWarning(message)
      })
    },
    updateIBVData (data) {
      const $this = this
      OriginationApi.updateIBVDataByLoanId(data, function (result) {
        if (data.ibvStatus === DataType.DecisionLogicRequestCodeStatusEnum.VERIFIED.value) {
          $this.$eventBus.$emit('updateIbvStatus')
        }
      })
    },
    decideStatus (item) {
      return item.amount >= 0 ? 'straight-amount' : ''
    },
    decideAmount (item) {
      return item.amount >= 0 ? '' : 'burden-amount'
    },
    manualSelectBankRecords () {
      const selected = this.selected
      if (tool.isEmpty(selected)) {
        this.$swal({
          type: 'info',
          text: 'Please select one transaction',
          showCancelButton: false
        })
        return
      }

      const bankRecordsData = []
      for (const selectItem of selected) {
        let endOfBalance = ''
        const transactionDate = selectItem.transactionDate
        for (const transactionsDataItem of this.transactionData) {
          if (transactionDate === transactionsDataItem.transactionDate) {
            endOfBalance = transactionsDataItem.balance
            break
          }
        }

        const bankRecordsDataItem = {}
        bankRecordsDataItem.loanId = this.loan.id
        bankRecordsDataItem.vob = DataType.VobEnum.IBV.value
        bankRecordsDataItem.payrollDate = selectItem.transactionDate
        bankRecordsDataItem.balance = endOfBalance
        bankRecordsDataItem.payrollType = DataType.PayrollTypeEnum.DIRECT_DEPOSIT.value
        bankRecordsDataItem.amount = selectItem.amount
        bankRecordsData.push(bankRecordsDataItem)
      }
      const bankRecordsDataFinalData = this.convertTime(bankRecordsData)
      const bankRecordsDataFinal = {
        bankRecordsDataFinalData: bankRecordsDataFinalData,
        provider: DataType.IBVProviderType.CHIRP.value
      }
      this.$eventBus.$emit('manualSelectBankRecords', bankRecordsDataFinal)
    },
    convertTime (bankRecordsData) {
      const bankRecordsDataFinal = []
      if (tool.isNotEmpty(bankRecordsData)) {
        const key = []
        for (const bankRecord of bankRecordsData) {
          if (!key.includes(bankRecord.payrollDate)) {
            bankRecordsDataFinal.push(bankRecord)
            key.push(bankRecord.payrollDate)
          } else {
            bankRecordsDataFinal[bankRecordsDataFinal.length - 1].amount += bankRecord.amount
          }
        }
      }
      return bankRecordsDataFinal
    }
  }
}
</script>

<style lang="css" scoped>
.first-title {
  color: #ad7442;
  font-size: 16px !important;
}
.next-title {
  color: #ad7442;
  margin-left: 18px;
  margin-bottom: 4px;
}
.checkbox-active {
  display: inline-block;
  margin-right: 20px;
}
::v-deep.v-input--selection-controls .v-input__slot > .v-label {
  font-size: 10px !important;
}
::v-deep.v-card {
  margin-top: 0 !important;
}
.v-card__title + .v-card__text {
  padding-top: 0;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 10px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 10px;
  vertical-align: bottom;
  line-height: 1.2;
}
.straight-amount {
  color: #008000;
}
.burden-amount {
  color: red;
}
</style>
